var exports = {
  "root": "x1cb7f6e3--693c31--root",
  "phone": "x1cb7f6e3--693c31--phone",
  "tablet": "x1cb7f6e3--693c31--tablet",
  "icon": "x1cb7f6e3--693c31--icon",
};

module.exports = exports;
